import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=d92d41e2&scoped=true&lang=pug&"
import script from "./VCheckbox.vue?vue&type=script&lang=js&"
export * from "./VCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=d92d41e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92d41e2",
  null
  
)

export default component.exports